import styled from 'styled-components';

import { createGlobalStyle } from 'styled-components';

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 96px 16px;
    }
  }
`;

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 90px;
  position: relative;
  background: #F7F8F9;
  padding-bottom: 0;
  margin-bottom: 24px;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: #C4C5C6;
    z-index: 0;
  }
`;

export const TabButton = styled.button<{ active: boolean }>`
  font-family: 'Caixa Std', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${({ active }) => (active ? '#00599C' : '#464646')};
  background: transparent;
  border: none;
  border-bottom: ${({ active }) => (active ? '2px solid #00599C' : 'none')};
  padding: 8px 0;
  margin: 0;
  outline: none;
  cursor: pointer;
  position: relative;
  transition: color 0.2s, border-bottom 0.2s;
  &:hover,
  &:focus {
    color: #00599C;
  }
`;
